import React, {useMemo} from "react";
import classnames from "classnames";
import {Col, Row} from "reactstrap";
import {Fade} from "@mui/material";
import {Check} from "@mui/icons-material";


/**
 * @typedef {{
 *     id: string | number,
 *     label: ReactNode,
 *     disabled: boolean,
 * }} StepperStep
 */

const StepperStepStatuses = {
    passed: 'passed',
    active: 'active',
    inactive: 'inactive',
}

/**
 * @param {StepperStep[]} stepProps
 * @param {string} activeStepId
 * @param {string} className
 * @param {Function} onClicked
 * @param {boolean} disableActiveLinesAtLast
 */
const Stepper = ({
                     steps: stepProps,
                     activeStepId,
                     className,
                     onClicked,
                     disableActiveLinesAtLast = false
                 }) => {
    /**@type {number}*/
    const activeIndex = useMemo(() => {
        return stepProps.findIndex(e => e.id === activeStepId);
    }, [stepProps, activeStepId])

    return (
        <div className={classnames('stepper-container', className)}>
            <Row className={'stepper-row'}>
                {
                    stepProps.map((step, index, array) => (
                        <StepperStep
                            key={step.id}
                            step={step}
                            onClicked={onClicked}
                            last={index === array.length - 1}
                            disableActiveLinesAtLast={activeIndex === array.length - 1 && disableActiveLinesAtLast}
                            status={
                                index > activeIndex
                                    ? StepperStepStatuses.inactive
                                    : index < activeIndex
                                        ? StepperStepStatuses.passed
                                        : StepperStepStatuses.active
                            }
                        />
                    ))
                }
            </Row>
        </div>
    );
}

/**
 * @param {Function} onClicked
 * @param {StepperStep} step
 * @param {StepperStepStatuses} status
 * @param {boolean} last
 * @param {boolean} disableActiveLinesAtLast
 */
const StepperStep = ({
                         onClicked,
                         step,
                         status,
                         last,
                         disableActiveLinesAtLast = false
                     }) => {
    const active = useMemo(() => status === StepperStepStatuses.active, [status])
    const inactive = useMemo(() => status === StepperStepStatuses.inactive, [status])
    const passed = useMemo(() => status === StepperStepStatuses.passed, [status])

    return (
        <>
            <Col className={'step'}>
                <div
                    className={classnames(
                        'ball',
                        {
                            'passed': passed,
                            'current': active,
                            'disabled': step.disabled || active,
                        }
                    )}
                    onClick={() => !step.disabled && !active && onClicked(step.id)}
                >
                    <div className={'label'}>
                        {step.label}
                    </div>
                    <Fade in={passed}>
                        <Check className={`icon small transition`}/>
                    </Fade>
                </div>
            </Col>
            {
                !last &&
                <Col className={'stepper-line-wrapper'}>
                    <div className={classnames('stepper-line', {'active': passed && !disableActiveLinesAtLast})}/>
                </Col>
            }
        </>
    );
}

export default Stepper;
